import { Offcanvas } from 'bootstrap';
import Util from '../common/util';
import ds from 'Shared/ds';

export default class Aside
{
    constructor(options, init = true) {
        this.options = options;

        if (init) {
            this.init();
        }
    }

    get offcanvasEl() { return document.getElementById(this.options.id); }
    get offcanvas() { return Offcanvas.getOrCreateInstance(this.offcanvasEl); }

    show = () => this.offcanvas.show();
    hide = () => this.offcanvas.hide();

    isOpen = ko.observable(false);

    init() {
        this.#bindEvents();
    }

    #bindEvents = () => {

        if (!this.offcanvasEl) {
            console.error(`Could not bind events, element with id '${this.options.id}' not found`);
            return;
        }

        this.offcanvasEl.addEventListener('show.bs.offcanvas', () => this.isOpen(true));
        this.offcanvasEl.addEventListener('hidden.bs.offcanvas', () => this.isOpen(false));
    }
}

export class DynamicTemplateAside extends Aside {
    constructor(options) {
        super(options, false);
    }

    loaded = ko.observable(false);
    loading = ko.observable(false);

    template = null;
    nodes = null;

    showTemplate = async(templateUrl, data) => {
        if (this.loaded()) {
            return;
        }

        if (templateUrl) {
            this.loading(true);

            const template = await ds.get(templateUrl, data);

            let nodes = Util.parseTemplate(template);
            
            let panel = document.createElement("div", {});
            panel.appendChild(nodes);

            this.nodes = panel.childNodes;

            this.loading(false);
        }

        this.loaded(true);
    }
}